import { EDPElevatorInfoColloquial } from '../../../models/edp/colloquials';
import { ElevatorBankHeader } from '../../actions-toolbar/actions-toolbar.model';

export enum ElevatorTypes {
  Empty = 'empty',
  Start = 'start',
  Stop = 'stop',
  LastStop = 'lastStop',
  ThickLine = 'thickLine',
  ThinLine = 'thinLine',
}
export interface ElevatorBankProcessed {
  elevatorType: ElevatorTypes;
  floorIndex?: number;
}
export interface EDPElevatorBank {
  id: number;
  elevator_type_desc?: string;
  elevator_bank_name: string;
  total_number_of_elevators?: number;
  start_floor: string;
  end_floor: string;
  elevator_bank_capacity?: number;
  elevator_bank_capacity_uom?: string;
  ada_compliant_f?: boolean;
  elevator_bank_notes?: string;
  colloquial?: EDPElevatorInfoColloquial[];
}

export const ELEVATOR_BANK_HEADERS: ElevatorBankHeader[] = [
  {
    field: 'elevatorTypeDesc',
    header: 'moreInfo.elevatorType',
    headerClass: 'floor-name-header',
    colClass: 'floor-name-col',
  },
  {
    field: 'elevatorBankName',
    header: 'moreInfo.bankName',
    required: true,
    headerClass: 'floor-name-header',
    colClass: 'bank-name-col',
  },
  {
    field: 'firstStop',
    header: 'moreInfo.firstStop',
    required: true,
    headerClass: 'floor-name-header',
    colClass: 'first-stop-col',
  },
  {
    field: 'lastStop',
    header: 'moreInfo.lastStop',
    required: true,
    headerClass: 'floor-name-header',
    colClass: 'last-stop-col',
  },
  {
    field: 'elevatorBankCapacity',
    header: 'moreInfo.elevatorBankCapacity',
    headerClass: 'floor-name-header',
    colClass: 'floor-name-col',
  },
  {
    field: 'adaCompliant',
    header: 'moreInfo.adaCompliant',
    headerClass: 'floor-name-header',
    colClass: 'floor-name-col',
  },
  {
    field: 'elevatorBankNotes',
    header: 'commonLabels.notes',
    headerClass: 'floor-name-header',
    colClass: 'floor-name-col',
  },
  {
    field: 'delete',
    header: 'moreInfo.delete',
    headerClass: 'floor-name-header',
    colClass: 'delete-floor',
  },
];
